import { AsyncActions } from '../../standard-actions/';
import { CHANNEL_CARE_LOAD_CASES_INT } from './action-types';
import { ICasesCCDResponse } from '../state/cases-int';

export interface ILoadCasesAction extends AsyncActions.IAsyncFetchableAction<CHANNEL_CARE_LOAD_CASES_INT> {
}

export interface ILoadCasesSuccessAction extends AsyncActions.IAsyncAction<CHANNEL_CARE_LOAD_CASES_INT> {
    data: ICasesCCDResponse;
}

export type LoadCasesErrorAction = AsyncActions.IAsyncErrorAction<CHANNEL_CARE_LOAD_CASES_INT>;

export const loadCasesStart = (): ILoadCasesAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: CHANNEL_CARE_LOAD_CASES_INT,
    isFetchable: true
});

export const loadCasesSuccess = (data: ICasesCCDResponse): ILoadCasesSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: CHANNEL_CARE_LOAD_CASES_INT,
    data
});

export const loadCasesError = (error: string): LoadCasesErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: CHANNEL_CARE_LOAD_CASES_INT,
    error
});
